import PropTypes from 'prop-types';

function IFGlutenFreeActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47825)">
                <path
                    d="M4.47748 12.5915C4.47748 12.5915 4.7941 14.303 7.22435 15.2314C9.6546 16.1599 10.7285 15.0603 10.7285 15.0603C10.3248 13.971 9.52172 13.0761 8.48226 12.5573C6.6938 11.7101 4.47748 12.5915 4.47748 12.5915Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.3087 8.78418C13.3087 8.78418 11.5972 9.10508 10.6688 11.5353C9.74031 13.9656 10.8399 15.0395 10.8399 15.0395C11.9302 14.6351 12.8253 13.8303 13.3429 12.789C14.1901 11.0005 13.3087 8.78418 13.3087 8.78418Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.13777 6.74695C6.13777 6.74695 14.0233 25.5729 15.3753 27.5924C15.6192 27.9475 17.2108 28.5251 17.0867 26.788C17.014 25.8681 7.86633 5.98535 7.86633 5.98535L6.13777 6.74695Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4362 15.9375C16.4362 15.9375 14.7247 16.2541 13.7963 18.6844C12.8336 21.1788 13.9674 22.1928 13.9674 22.1928C15.0577 21.7885 15.9528 20.9836 16.4704 19.9423C17.3176 18.1624 16.4362 15.9375 16.4362 15.9375Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.1289 3.6582C10.6154 3.65736 8.15808 4.40192 6.06779 5.79772C3.97749 7.19352 2.34807 9.17787 1.38562 11.4998C0.423162 13.8217 0.170901 16.3769 0.660739 18.8422C1.15058 21.3075 2.36051 23.5721 4.13751 25.3497C5.91452 27.1273 8.17877 28.338 10.6439 28.8287C13.109 29.3194 15.6643 29.068 17.9865 28.1063C20.3088 27.1446 22.2937 25.5159 23.6902 23.426C25.0867 21.3362 25.8321 18.8792 25.8321 16.3657C25.8321 12.9962 24.4938 9.76465 22.1116 7.38165C19.7294 4.99866 16.4983 3.65934 13.1289 3.6582ZM15.649 14.5216C17.0866 13.3621 21.2967 9.32309 21.2967 9.32309C21.5321 9.60976 22.4648 10.8719 22.5461 11.0345C23.4813 12.6819 23.9681 14.5456 23.9582 16.4399C23.9482 18.3341 23.4417 20.1927 22.4892 21.8301C21.5367 23.4675 20.1715 24.8265 18.5299 25.7716C16.8882 26.7167 15.0274 27.2148 13.1331 27.2163C10.0354 27.2163 6.95909 25.4021 5.00376 23.3227C4.85829 23.173 8.7775 20.2122 8.7775 20.2122C8.7775 20.2122 13.9204 15.9378 15.649 14.5216ZM3.72018 21.2904C2.90724 20.1908 2.2954 18.0172 2.2954 16.3657C2.29654 13.4932 3.43841 10.7388 5.46996 8.70805C7.5015 6.67731 10.2564 5.53652 13.1289 5.53652C15.5505 5.53652 18.0065 6.79871 19.5938 8.22776L3.72018 21.2904Z"
                    fill="#E95CA2"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.64638 8.27013C2.64638 8.27013 2.96727 9.98158 5.39753 10.91C7.82778 11.8385 8.90171 10.7389 8.90171 10.7389C8.49734 9.64859 7.6925 8.75348 6.65116 8.2359C4.8627 7.38018 2.64638 8.27013 2.64638 8.27013Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.60509 19.7498C7.60509 19.7498 7.9217 21.4612 10.352 22.394C12.7822 23.3267 13.8561 22.2228 13.8561 22.2228C13.4512 21.1318 12.6467 20.2355 11.6056 19.7156C9.83852 18.8727 7.60509 19.7498 7.60509 19.7498Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.4817 4.46191C11.4817 4.46191 9.77024 4.78281 8.8375 7.21306C7.90476 9.64332 9.01292 10.7172 9.01292 10.7172C10.1032 10.3129 10.9983 9.50804 11.5159 8.4667C12.3631 6.67824 11.4817 4.46191 11.4817 4.46191Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.04665 2.78125C5.04665 2.78125 4.16953 4.27877 5.3975 6.57638C6.62546 8.874 8.16576 8.73708 8.16576 8.73708C8.5712 7.64666 8.54673 6.44285 8.0973 5.36981C7.2972 3.56424 5.04665 2.78125 5.04665 2.78125Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.3384 19.7288C20.3384 19.7288 21.7504 18.719 21.5707 16.1219C21.3867 13.4563 19.932 13.0156 19.932 13.0156C19.1152 13.8434 18.6441 14.9509 18.6141 16.1133C18.6056 18.0772 20.3384 19.7288 20.3384 19.7288Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.7927 22.5565C17.7927 22.5565 19.5041 22.7576 21.1257 20.7081C22.7473 18.6587 21.9814 17.3066 21.9814 17.3066C20.8202 17.3735 19.7279 17.8798 18.9265 18.7229C17.6001 20.1819 17.7927 22.5565 17.7927 22.5565Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.6421 19.168L19.5682 20.5542"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.4667 17.6874L20.0773 15.4668"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47825">
                    <rect width="27.7126" height="31.3751" fill="white" transform="translate(0.100647 0.675781)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFGlutenFreeActive;

IFGlutenFreeActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFGlutenFreeActive.defaultProps = {
    className: null,
    width: 28,
};
